export default __webpack_public_path__ + "static/media/Mercedes-Benz-minimal.dc4d4c3a.png";